import { css } from "@emotion/react";

import { Notification as NotificationType } from "./types";
import Notification from "./Notification";

type Props = {
  notifications: NotificationType[];
  onDismiss: (id: string) => void;
  timeout: number;
};

const rootStyle = css`
  align-items: center;
  display: grid;
  grid-gap: 20px;
  justify-content: center;
  left: 0;
  position: fixed;
  top: 65px;
  width: 100vw;
  z-index: 1000;
`;

function Notifications(props: Props) {
  const notifications = props.notifications.map((notification, i) => (
    <Notification
      index={i}
      key={notification.id}
      notification={notification}
      onDismiss={props.onDismiss}
      timeout={notification.timeout ?? props.timeout}
    />
  ));

  return (
    <section css={rootStyle} data-test="notifications">
      {notifications}
    </section>
  );
}

export default Notifications;
